// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "04074f07ba0a0569d4d26ac2cc351491f72774b5/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};